export default __webpack_public_path__ + "images/4a415f41fed067b4aab2d5a3369cb28c-EE_SlideDeckBOOK1024_8.png";